import { UiSplitSectionModel } from "../../models";

export function mockUiSplitSectionModel({
    id = "split-section-1234",
    type = "uiSplitSection",
    locale = "en",
    content = mockUiSplitSectionModelContent()
}: Partial<UiSplitSectionModel> = {}): UiSplitSectionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiSplitSectionModelContent = UiSplitSectionModel["content"];

export function mockUiSplitSectionModelContent({
    entryTitle = "Test split section",
    useEyebrowLogo = false,
    ...optionals
}: Partial<UiSplitSectionModelContent> = {}): UiSplitSectionModelContent {
    return {
        entryTitle,
        useEyebrowLogo,
        ...optionals
    };
}
